import { CITY } from '@city'

/**
 * The website's analytics providers in the privacy policy's third-party
 * list — shown only where the city runs web analytics (`CITY.webAnalytics`).
 * Amplitude also covers the Application, so its entry names both.
 */
export function WebAnalyticsProviders() {
  return (
    <>
      <li>
        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
          Google Analytics 4
        </a>{' '}
        — web analytics (property {CITY.webAnalytics?.ga4MeasurementId}); cookies <code>_ga</code>,{' '}
        <code>_gid</code>; IP addresses anonymised.
      </li>
      <li>
        <a href="https://amplitude.com/privacy" target="_blank" rel="noopener noreferrer">
          Amplitude
        </a>{' '}
        — product analytics on the website and in the Application (event-level usage statistics,
        including the tracking-link channel above); web storage keys <code>AMP_*</code>. If you have
        not consented to analytics on the website, Amplitude still receives usage events, but
        nothing is stored on your device and no IP address is sent: the events carry a pseudonymous
        identifier our server derives from your network and browser with a key it discards every
        day, so visits on different days cannot be linked.
      </li>
    </>
  )
}
